import ComparativaPreview from "./ComparativaPreview";
export default ComparativaPreview;